const apihost='https://api.insightnest.tech';

export default apihost;